import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";
import * as moment from "moment";
import { SupportService } from "../services/support-service";

@Component({
  selector: "app-plan-subscription",
  templateUrl: "./plan-subscription.component.html",
  styleUrls: ["./plan-subscription.component.scss"],
})
export class PlanSubscriptionComponent implements OnInit {
  planList: any = "";
  isDisabled = false;
  duration;
  isLoad = false;
  testCountryCode = "";
  profilenotfill = false;

  constructor(
    private router: Router,
    private supportService: SupportService,
    private appservice: AppService
  ) {}

  ngOnInit() {
    this.getPlanList();
    this.viewTestCenter();
  }

  getPlanList() {
    this.appservice
      .getPlanList(localStorage.getItem("testCenterId").toString())
      .subscribe((plan) => {
        if (plan["status"]["status"] === 200) {
          this.isLoad = true;
          this.planList = plan["entity"];
          if (this.planList) {
            this.isDisabled = true;
            const comingdate = new Date(this.planList.expiredDateStr);
            comingdate.setHours(0);
            comingdate.setMinutes(0);
            const currentdate = new Date();
            currentdate.setHours(0);
            currentdate.setMinutes(0);
            this.duration =
              Math.round(
                (comingdate.getTime() - currentdate.getTime()) /
                  (1000 * 3600 * 24)
              );
          }
        } else if (plan["status"]["status"] === 204) {
          this.isLoad = true;
        }
      });
  }

  viewTestCenter() {
    this.appservice.viewtestcenter().subscribe(
      (res) => {
        if (
          res &&
          res["status"] &&
          res["status"] &&
          res["status"]["status"] === 200
        ) {
          if (
            res["entity"] &&
            res["entity"]["address"] &&
            res["entity"]["address"]["country"]
          ) {
            this.testCountryCode =
              res["entity"]["address"]["country"]["countryCode"];
            this.profilenotfill = false;
          } else {
            this.testCountryCode = localStorage.getItem(
              "currentlocationcountry"
            )
              ? localStorage.getItem("currentlocationcountry") === "101"
                ? "IN"
                : "US"
              : "";
            this.profilenotfill = true;
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  gotoCard() {
    this.supportService.isAccept = true;
    localStorage.setItem("pendingCreditCardOnboarding", "true");
    this.router.navigate([
      `/${localStorage.getItem("testCode").toString()}/credit-card`,
    ]);
  }
}
